import { fetchDataAPI } from '../helpers/fetchDataAPI';
import { URL_BASE_API } from './glogal';
import { store } from '../store'


export const getCountries = () => {
    const url = `${URL_BASE_API}/api/catalog/countries`;
    const language = store.getState().configuration.language;
    const rsp = fetchDataAPI(url, {
        lang: language
    });
    
    return rsp;
}
